import { useState, useEffect, useRef } from "react";
import Pusher from "pusher-js";

const PUSHER_KEY     = "c4653cc5a9f2411e6d66";
const PUSHER_CLUSTER = "ap2";
const SERVER         = "https://yap-wars-backend.onrender.com";

async function emit(roomCode, event, data) {
  try {
    await fetch(`${SERVER}/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ channel: "game-" + roomCode, event, data }),
    });
  } catch (e) { console.error("emit failed:", e); }
}

// ── Sound Effects ─────────────────────────────────────────────
const AudioCtx = typeof window !== "undefined" ? (window.AudioContext || window.webkitAudioContext) : null;
let audioCtx = null;
function getAudioCtx() {
  if (!audioCtx && AudioCtx) audioCtx = new AudioCtx();
  return audioCtx;
}
function playSound(type) {
  try {
    const ctx = getAudioCtx();
    if (!ctx) return;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.connect(g); g.connect(ctx.destination);
    const now = ctx.currentTime;
    if (type === "tick") {
      o.frequency.setValueAtTime(880, now);
      g.gain.setValueAtTime(0.08, now);
      g.gain.exponentialRampToValueAtTime(0.001, now + 0.08);
      o.start(now); o.stop(now + 0.08);
    } else if (type === "lock") {
      o.frequency.setValueAtTime(523, now);
      o.frequency.setValueAtTime(659, now + 0.1);
      g.gain.setValueAtTime(0.15, now);
      g.gain.exponentialRampToValueAtTime(0.001, now + 0.3);
      o.start(now); o.stop(now + 0.3);
    } else if (type === "reveal") {
      o.type = "sine";
      o.frequency.setValueAtTime(392, now);
      o.frequency.linearRampToValueAtTime(784, now + 0.4);
      g.gain.setValueAtTime(0.18, now);
      g.gain.exponentialRampToValueAtTime(0.001, now + 0.5);
      o.start(now); o.stop(now + 0.5);
    } else if (type === "win") {
      [523,659,784,1047].forEach((f,i) => {
        const oo = ctx.createOscillator();
        const gg = ctx.createGain();
        oo.connect(gg); gg.connect(ctx.destination);
        oo.frequency.setValueAtTime(f, now + i*0.12);
        gg.gain.setValueAtTime(0.15, now + i*0.12);
        gg.gain.exponentialRampToValueAtTime(0.001, now + i*0.12 + 0.25);
        oo.start(now + i*0.12); oo.stop(now + i*0.12 + 0.25);
      });
    }
  } catch(e) {}
}

const QUESTIONS = [
  "What's the worst superpower to have on a date?",
  "What's something you'd only confess to a stranger on a plane?",
  "What's the most useless talent a person can have?",
  "If you could only eat one food forever, what would make you regret it most?",
  "What's the dumbest thing humans do that aliens would judge us for?",
  "What's a job that sounds glamorous but is secretly terrible?",
  "What would be the worst name for a baby?",
  "What's something you'd be embarrassed to Google?",
  "What's the most overrated experience everyone pretends to love?",
  "What's the worst thing you could accidentally text your boss?",
  "If laziness was a sport, what would the gold medal event be?",
  "What's the most chaotic thing to say at a wedding speech?",
  "What's a skill that sounds impressive until you explain it?",
  "What's the worst genre of music to be stuck in an elevator with?",
  "What would be the worst surprise inside a birthday cake?",
  "If you had to describe yourself using only a kitchen appliance, what would it be?",
  "What's the most passive-aggressive gift you could give someone?",
  "What's the worst thing to say when meeting your partner's parents for the first time?",
  "What would be the least useful museum exhibit?",
  "What's the worst Wi-Fi name a neighbor could have?",
  "What's the most suspicious thing someone can do at an airport?",
  "What's the worst topping to add to a pizza?",
  "What bad habit would be hardest to give up if it were completely healthy?",
  "What's the most dramatic way to quit a job?",
  "What's a terrible slogan for a children's toy?",
  "What would be the worst thing to find in your hotel room?",
  "What's the most unrealistic thing action heroes do that bugs you?",
  "What's the weirdest law that should actually exist?",
  "What's a movie plot that's actually just describing your daily life?",
  "What's the most absurd thing to put on a resume?",
  "What would a terrible therapist say?",
  "What's the worst genre for the first song at a wedding?",
  "What's the most useless invention you'd still secretly buy?",
  "What would be the worst flavor for a perfume?",
  "What's the most dramatic thing you could do at a grocery store?",
  "What's the worst advice to give someone starting a diet?",
  "If your personality was a weather forecast, what would it be?",
  "What's the most awkward thing to say during a job interview?",
  "What's the worst place to fall asleep?",
  "What animal would make the worst motivational speaker?",
  "What's the most unnecessary warning label that should exist?",
  "What would be the worst power outage activity?",
  "What's the most cringe-worthy pickup line that someone actually thinks works?",
  "What's the worst plot twist for a Disney movie?",
  "What's something you'd see in a horror movie that barely fazes you?",
  "What's the worst thing to name a restaurant?",
  "What would be the most boring superhero origin story?",
  "What's the worst thing to say during a group photo?",
  "What's the most overconfident dish to bring to a potluck?",
  "What's the most impractical fashion trend that should make a comeback?",
  "What's the worst career advice a parent could give?",
  "What's the most suspicious hobby to have?",
  "What's the worst thing to discover about yourself on a reality TV show?",
  "What's the most dramatic response to being asked what you want for dinner?",
  "What's the worst tattoo to get for your first one?",
  "What's the most passive thing you've done to avoid a conversation?",
  "What would be the worst country to visit if you have a severe phobia of something common?",
  "What's the most unhinged thing you'd do for free Wi-Fi?",
  "What's the worst thing to put in a time capsule?",
  "What's a terrible piece of relationship advice from a movie?",
  "What's the most annoying personality trait that someone thinks is charming?",
  "What's the worst thing to bring to a camping trip?",
  "What would be the most chaotic school mascot?",
  "What's the most awkward thing to say when breaking up with someone?",
  "What's the worst food to serve at a funeral reception?",
  "What's an everyday item that would make a terrifying weapon?",
  "What's the worst thing to say when someone shows you their new baby?",
  "What's the most dramatic way to return a library book?",
  "What would be the worst thing to find out about your Uber driver mid-ride?",
  "What's the most unnecessary life skill someone can be proud of?",
  "What's the worst soundtrack for a first date?",
  "What's a red flag that people somehow think is cute?",
  "What's the worst thing to say when someone's crying?",
  "What would be the least inspiring motivational poster?",
  "What's the most overhyped holiday tradition?",
  "What's the worst way to end a speech?",
  "What's the most absurd thing to get a PhD in?",
  "What's the worst thing your autocorrect could change in a work email?",
  "What's the most over-the-top way to cancel plans?",
  "What's the worst-timed sneeze you could imagine?",
  "What's the most chaotic first sentence of a novel?",
  "What would be the worst companion animal for someone with no patience?",
  "What's the most unnecessarily intense thing someone can do at a coffee shop?",
  "What's the worst job perk a company could offer?",
  "What's the most annoying way someone can respond to 'How are you?'",
  "What's the worst thing to say in a hostage negotiation?",
  "What would be the most useless feature in a self-driving car?",
  "What's the most dramatic thing you could do if your flight is delayed?",
  "What's the worst-timed phone call to receive?",
  "What's the most suspicious thing to have in your grocery cart?",
  "What's the worst skill to show off at a talent show?",
  "What would be the most disappointing magic trick?",
  "What's the most chaotic energy drink flavor that would sell too well?",
  "What's the worst way to introduce yourself at a party?",
  "What's the most inconvenient time to suddenly become very principled?",
  "What's the worst thing to put on a motivational mug?",
  "What's the most unnecessary thing to be competitive about?",
  "What's the worst ice breaker question for a job interview?",
  "What's the most passive-aggressive way to say you're fine?",
  "What would be the most underwhelming end to a blockbuster movie?",
];

const genId   = () => Math.random().toString(36).substr(2, 9);
const genCode = () => Math.random().toString(36).substr(2, 4).toUpperCase();

const C = {
  bg:"#0a0814", surface:"#13102a", surface2:"#1e1a38", surface3:"#272245",
  accent:"#ff4d6d", yellow:"#ffd60a", cyan:"#4cc9f0", purple:"#7b2ff7",
  text:"#f0eeff", muted:"#8b82b0", border:"rgba(255,255,255,0.07)",
};

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800;900&family=Outfit:wght@400;500;600&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  html,body,#root{height:100%}
  body{font-family:'Outfit',sans-serif;background:${C.bg};color:${C.text};min-height:100vh}
  input,textarea,select{font-family:'Outfit',sans-serif}
  ::-webkit-scrollbar{width:4px}
  ::-webkit-scrollbar-thumb{background:${C.surface3};border-radius:2px}
  @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
  @keyframes pop{0%{transform:scale(.85);opacity:0}65%{transform:scale(1.04)}100%{transform:scale(1);opacity:1}}
  @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
  @keyframes gradShift{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}
  @keyframes urgentPulse{0%,100%{opacity:1}50%{opacity:.55}}
  @keyframes spotlight{0%{opacity:0;transform:scale(.8)}20%{opacity:1;transform:scale(1.05)}80%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.95)}}
  @keyframes scoreCount{from{transform:scale(1.3);color:${C.yellow}}to{transform:scale(1)}}
  @keyframes confettiFall{0%{transform:translateY(-20px) rotate(0deg);opacity:1}100%{transform:translateY(100vh) rotate(720deg);opacity:0}}
  .fadeUp{animation:fadeUp .35s ease both}
  .pop{animation:pop .35s cubic-bezier(.34,1.56,.64,1) both}
  .pulse{animation:pulse 1.6s ease infinite}
  .grad-text{background:linear-gradient(135deg,${C.accent},${C.yellow},${C.cyan});background-size:200% 200%;animation:gradShift 4s ease infinite;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
  .timer-bar{width:100%;height:5px;background:${C.surface3};border-radius:3px;overflow:hidden;margin:8px 0 18px}
  .timer-fill{height:100%;border-radius:3px;transition:width 1s linear;background:linear-gradient(90deg,${C.cyan},${C.purple})}
  .timer-fill.urgent{background:linear-gradient(90deg,${C.accent},#ff8c00);animation:urgentPulse .5s ease infinite}
  .ans-card{background:${C.surface2};border:1.5px solid ${C.border};border-radius:14px;padding:16px 20px;cursor:pointer;transition:all .18s;margin-bottom:10px;display:flex;align-items:center;gap:14px}
  .ans-card:hover:not(.blocked){border-color:${C.cyan};background:rgba(76,201,240,.07);transform:translateX(4px)}
  .ans-card.selected{border-color:${C.cyan};background:rgba(76,201,240,.1)}
  .ans-card.blocked{cursor:not-allowed;opacity:.45}
  .chip{padding:5px 13px;border-radius:50px;font-size:.8rem;font-weight:500;background:${C.surface3};border:1px solid ${C.border};display:inline-flex;align-items:center;gap:6px}
  .chip.host{border-color:rgba(255,214,10,.4);color:${C.yellow}}
  .res-item{background:${C.surface2};border:1px solid ${C.border};border-radius:14px;padding:14px 18px;margin-bottom:8px;display:flex;align-items:center;gap:12px}
  .res-item.r1{border-color:rgba(255,214,10,.4);background:rgba(255,214,10,.04)}
  .res-item.r2{border-color:rgba(192,192,192,.35)}
  .res-item.r3{border-color:rgba(205,127,50,.35)}
  .sc-row{display:flex;align-items:center;gap:12px;padding:11px 0;border-bottom:1px solid ${C.border}}
  .sc-row:last-child{border-bottom:none}
  .score-animated{animation:scoreCount .4s ease both}
  .spotlight-overlay{position:fixed;inset:0;background:rgba(0,0,0,.85);display:flex;align-items:center;justify-content:center;z-index:100;animation:spotlight 3s ease forwards}
  .confetti-piece{position:fixed;pointer-events:none;animation:confettiFall linear forwards}
  .reaction-btn{background:${C.surface2};border:1px solid ${C.border};border-radius:50px;padding:8px 16px;cursor:pointer;font-size:0.85rem;transition:all .15s;color:${C.text}}
  .reaction-btn:hover{background:${C.surface3};transform:scale(1.05)}
  /* AD SLOT */
  .ad-slot{display:none}
  @keyframes screenPulse{0%,100%{box-shadow:inset 0 0 0px rgba(255,77,109,0)}50%{box-shadow:inset 0 0 100px rgba(255,77,109,0.22)}}
  @keyframes particleFly{0%{transform:translate(0,0) scale(1);opacity:1}100%{transform:translate(var(--dx),var(--dy)) scale(0);opacity:0}}
  @keyframes reactionRain{0%{transform:translateY(-60px) scale(0.4);opacity:0}15%{opacity:1;transform:translateY(-30px) scale(1.1)}85%{opacity:0.9}100%{transform:translateY(105vh) scale(0.8);opacity:0}}
  @keyframes roundIntroAnim{0%{opacity:0;transform:scale(1.5)}15%{opacity:1;transform:scale(1)}85%{opacity:1}100%{opacity:0;transform:scale(0.85)}}
  @keyframes streakBounce{0%,100%{transform:scale(1)}50%{transform:scale(1.5) rotate(10deg)}}
  @keyframes coffeeWiggle{0%,100%{transform:rotate(0deg)}25%{transform:rotate(-18deg)}75%{transform:rotate(18deg)}}
  @keyframes roastSlide{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}
  @keyframes scoreFlash{0%{transform:scale(1.6);color:#ffd60a;text-shadow:0 0 16px #ffd60a88}100%{transform:scale(1);color:#4cc9f0;text-shadow:none}}
  @keyframes gainedPts{from{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:translateY(0)}}
  .screen-urgent{animation:screenPulse 0.5s ease infinite}
  .particle{position:fixed;pointer-events:none;border-radius:50%;animation:particleFly ease forwards;z-index:800}
  .reaction-rain-drop{position:fixed;top:-60px;pointer-events:none;font-size:2rem;animation:reactionRain linear forwards;z-index:700}
  .round-intro-overlay{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:600;background:#0a0814;animation:roundIntroAnim 1.8s ease forwards;pointer-events:none}
  .streak-fire{display:inline-block;animation:streakBounce 0.9s ease infinite;margin-left:4px}
  .roast-msg{animation:roastSlide 0.3s ease both;font-size:0.68rem;color:#ff4d6d;margin-top:2px;font-style:italic}
  .score-flash{animation:scoreFlash 0.7s ease both}
  .gained-pts{animation:gainedPts 0.4s ease both;font-size:0.68rem;color:#4ade80;font-weight:700}
  .coffee-btn{position:fixed;bottom:70px;right:20px;z-index:499;display:flex;align-items:center;gap:0;background:rgba(19,16,42,0.95);border:1px solid rgba(255,255,255,0.08);border-radius:50px;padding:9px 12px;cursor:pointer;transition:all 0.35s cubic-bezier(.34,1.56,.64,1);overflow:hidden;white-space:nowrap;text-decoration:none;color:#f0eeff;backdrop-filter:blur(10px);box-shadow:0 4px 20px rgba(0,0,0,0.3)}
  .coffee-btn:hover{border-color:rgba(255,214,10,0.4);background:rgba(255,214,10,0.06);transform:translateY(-3px) scale(1.04);box-shadow:0 8px 30px rgba(255,214,10,0.15)}
  .coffee-emoji{font-size:1.15rem;transition:transform 0.3s}
  .coffee-btn:hover .coffee-emoji{animation:coffeeWiggle 0.45s ease}
  .coffee-label{max-width:0;overflow:hidden;opacity:0;font-size:0.82rem;font-weight:600;color:#ffd60a;transition:max-width 0.35s ease,opacity 0.3s ease,margin 0.35s ease;margin-left:0}
  .coffee-btn:hover .coffee-label{max-width:140px;opacity:1;margin-left:8px}
  /* Fix 10: Responsiveness */
  @media(max-width:400px){
    .chip{font-size:.72rem;padding:4px 10px}
    .ans-card{padding:12px 14px;gap:10px}
    .res-item{padding:10px 12px;gap:8px}
  }
`;

function Btn({ children, onClick, variant="primary", disabled }) {
  const vs = {
    primary:{ background:C.accent, color:"#fff", border:"none" },
    ghost:  { background:"transparent", color:C.cyan, border:`1.5px solid ${C.cyan}` },
    danger: { background:"rgba(255,77,109,.15)", color:C.accent, border:`1px solid rgba(255,77,109,.3)` },
  };
  return (
    <button onClick={disabled?undefined:onClick} style={{
      ...vs[variant], display:"flex", alignItems:"center", justifyContent:"center",
      gap:8, padding:"13px 24px", borderRadius:50, fontSize:"0.95rem", fontWeight:600,
      cursor:disabled?"not-allowed":"pointer", width:"100%",
      fontFamily:"'Outfit',sans-serif", opacity:disabled?.4:1, transition:"all .18s",
    }}
    onMouseEnter={e=>{ if(!disabled) e.currentTarget.style.transform="translateY(-2px)"; }}
    onMouseLeave={e=>{ e.currentTarget.style.transform=""; }}>
      {children}
    </button>
  );
}

const iStyle = { width:"100%", padding:"12px 15px", background:C.surface2, border:`1px solid ${C.border}`, borderRadius:12, color:C.text, fontSize:"1rem", outline:"none" };

function Card({ children, style:ex, className="" }) {
  return <div className={className} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:20, padding:26, ...ex }}>{children}</div>;
}

function QBox({ question, round, total }) {
  return (
    <div className="fadeUp" style={{ background:`linear-gradient(135deg,${C.surface2},#221c46)`, border:`1px solid rgba(123,47,247,.35)`, borderRadius:18, padding:"26px 22px", textAlign:"center", marginBottom:18 }}>
      <div style={{ display:"inline-block", padding:"3px 13px", borderRadius:50, background:"rgba(123,47,247,.22)", color:C.cyan, fontSize:"0.74rem", fontWeight:600, marginBottom:12, border:`1px solid rgba(76,201,240,.22)`, letterSpacing:1 }}>
        ROUND {round} OF {total}
      </div>
      <p style={{ fontFamily:"'Syne',sans-serif", fontSize:"clamp(1.05rem,3vw,1.35rem)", fontWeight:700, lineHeight:1.4 }}>{question}</p>
    </div>
  );
}

function Dots({ current, total }) {
  return (
    <div style={{ display:"flex", gap:6, justifyContent:"center", marginBottom:18 }}>
      {Array.from({length:total},(_,i)=>(
        <div key={i} style={{ width:i+1===current?20:8, height:8, borderRadius:4, transition:"all .3s", background:i+1<current?C.purple:i+1===current?C.accent:C.surface3 }} />
      ))}
    </div>
  );
}

function TimerBar({ remaining, total, soundEnabled }) {
  const urgent = remaining<=10;
  useEffect(()=>{
    if(soundEnabled && urgent && remaining>0 && remaining<=5) playSound("tick");
  },[remaining]);
  useEffect(()=>{
    if(urgent && remaining>0) document.body.classList.add("screen-urgent");
    else document.body.classList.remove("screen-urgent");
    return ()=>document.body.classList.remove("screen-urgent");
  },[urgent, remaining]);
  return (
    <>
      <div style={{ textAlign:"center", fontSize:"0.83rem", color:urgent?C.accent:C.muted, marginBottom:4, fontWeight:500 }}>{remaining}s remaining</div>
      <div className="timer-bar"><div className={`timer-fill${urgent?" urgent":""}`} style={{ width:`${Math.max(0,(remaining/total)*100)}%` }} /></div>
    </>
  );
}

// Spotlight screen — winner of the round gets 3s glory
function SpotlightScreen({ winner, onDone }) {
  useEffect(()=>{
    playSound("win");
    const t = setTimeout(onDone, 3000);
    return ()=>clearTimeout(t);
  },[]);
  return (
    <div className="spotlight-overlay">
      <div style={{ textAlign:"center", padding:32 }}>
        <div style={{ fontSize:"5rem", marginBottom:16 }}>🏆</div>
        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"0.8rem", fontWeight:700, letterSpacing:3, color:C.cyan, textTransform:"uppercase", marginBottom:8 }}>Best Answer This Round</div>
        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"clamp(1.4rem,4vw,2.2rem)", fontWeight:900, color:C.yellow, marginBottom:12, lineHeight:1.2 }}>
          "{winner.text}"
        </div>
        <div style={{ color:C.muted, fontSize:"0.9rem" }}>— {winner.authorName}</div>
        <div style={{ marginTop:16, display:"flex", justifyContent:"center", gap:8, flexWrap:"wrap" }}>
          {["🔥","👑","💀","😂"].map(e=>(
            <span key={e} style={{ fontSize:"1.8rem", animation:`pop .3s ease both`, animationDelay:`${Math.random()*0.4}s` }}>{e}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

// Confetti burst for final screen
function Confetti() {
  const pieces = Array.from({length:30},(_,i)=>({
    id:i, left:`${Math.random()*100}%`,
    color:["#ff4d6d","#ffd60a","#4cc9f0","#7b2ff7","#4ade80"][Math.floor(Math.random()*5)],
    size: 6+Math.random()*8,
    duration: 2+Math.random()*2,
    delay: Math.random()*1,
  }));
  return (
    <>
      {pieces.map(p=>(
        <div key={p.id} className="confetti-piece" style={{
          left:p.left, top:"-20px", width:p.size, height:p.size,
          background:p.color, borderRadius:Math.random()>0.5?"50%":"2px",
          animationDuration:`${p.duration}s`, animationDelay:`${p.delay}s`,
        }} />
      ))}
    </>
  );
}

// ── Main App ──────────────────────────────────────────────────
export default function App() {
  const [screen, setScreen]     = useState("home");
  const [tab,    setTab]        = useState("host");
  const [toast,  setToast]      = useState(null);
  const [joining,setJoining]    = useState(false);
  const [soundOn,setSoundOn]    = useState(true);
  const [showSpotlight, setShowSpotlight] = useState(false);
  const [spotlightWinner, setSpotlightWinner] = useState(null);

  const myId = useRef(genId()).current;
  const [myName,  setMyName]    = useState("");
  const [isHost,  setIsHost]    = useState(false);
  const [roomCode,setRoomCode]  = useState("");

  const cfg = useRef({ totalRounds:5, answerTime:45, voteTime:30 });

  const [players,      setPlayers]      = useState({});
  const [scores,       setScores]       = useState({});
  const [round,        setRound]        = useState(0);
  const [question,     setQuestion]     = useState("");
  const [ansTimer,     setAnsTimer]     = useState(45);
  const [votTimer,     setVotTimer]     = useState(30);
  const [answerText,   setAnswerText]   = useState("");
  const [answerLocked, setAnswerLocked] = useState(false);
  const [subCount,     setSubCount]     = useState(0);
  const [myVote,       setMyVote]       = useState(null);
  const [shuffled,     setShuffled]     = useState([]);
  const [results,      setResults]      = useState({ answers:{}, scores:{}, question:"" });
  const [twoPlayer,    setTwoPlayer]    = useState(false);
  const [reactions,    setReactions]    = useState([]);
  const [rainDrops,    setRainDrops]    = useState([]);
  const [particles,    setParticles]    = useState([]);
  const [streaks,      setStreaks]      = useState({});
  const [showRoundIntro, setShowRoundIntro] = useState(false);
  const [introRound,   setIntroRound]   = useState(1);
  const [roundRecap,   setRoundRecap]   = useState(null);
  const [hostLeft,     setHostLeft]     = useState(false);
  const [playerLeftMsg,setPlayerLeftMsg]= useState(null);
  const [waitingRejoin,setWaitingRejoin]= useState(false);
  const lastReactionRef = useRef(0);
  const prevScoresRef   = useRef({});

  const playersRef   = useRef({});
  const scoresRef    = useRef({});
  const answersRef   = useRef({});
  const usedQ        = useRef([]);
  const roundRef     = useRef(0);
  const qRef         = useRef("");
  const roomRef      = useRef("");
  const isHostRef    = useRef(false);
  const myNameRef    = useRef("");
  const channelRef   = useRef(null);
  const ansTimerRef  = useRef(null);
  const votTimerRef  = useRef(null);
  const ansLockedRef = useRef(false);
  const myVoteRef    = useRef(null);
  const shuffledRef     = useRef([]);
  const allResultsRef   = useRef([]);
  const resultsShownRef = useRef(false);

  useEffect(()=>{ playersRef.current = players; },[players]);
  useEffect(()=>{ scoresRef.current  = scores;  },[scores]);
  useEffect(()=>{ ansLockedRef.current = answerLocked; },[answerLocked]);
  useEffect(()=>{ myVoteRef.current = myVote; },[myVote]);
  useEffect(()=>{ shuffledRef.current = shuffled; },[shuffled]);

  useEffect(()=>{
    const el = document.createElement("style");
    el.textContent = CSS;
    document.head.appendChild(el);
    return ()=>document.head.removeChild(el);
  },[]);

  const showToast = (msg, ms=2500) => { setToast(msg); setTimeout(()=>setToast(null), ms); };

  // ── Timers ──
  function startAnsTimer(duration) {
    clearInterval(ansTimerRef.current);
    setAnsTimer(duration);
    let rem = duration;
    ansTimerRef.current = setInterval(()=>{
      rem--;
      setAnsTimer(rem);
      if (rem<=0) {
        clearInterval(ansTimerRef.current);
        if (!ansLockedRef.current) submitAnswer("(passed)");
      }
    }, 1000);
  }

  function startVotTimer(duration) {
    clearInterval(votTimerRef.current);
    setVotTimer(duration);
    let rem = duration;
    votTimerRef.current = setInterval(()=>{
      rem--;
      setVotTimer(rem);
      if (rem<=0) {
        clearInterval(votTimerRef.current);
        if (!myVoteRef.current) {
          const others = shuffledRef.current.map(([id])=>id).filter(id=> id!==myId || Object.keys(playersRef.current).length===2);
          if (others.length>0) {
            const randomId = others[Math.floor(Math.random()*others.length)];
            myVoteRef.current = randomId;
            setMyVote(randomId);
            emit(roomRef.current, "vote-in", { voterId:myId, votedFor:randomId });
          }
        }
        if (isHostRef.current) finalizeVotes();
      }
    }, 1000);
  }

  // ── Pusher setup ──
  function setupPusher(code, hostMode, id, name, onNameTaken) {
    if (channelRef.current) {
      channelRef.current.unbind_all();
      channelRef.current.pusher?.disconnect();
    }
    const pusher = new Pusher(PUSHER_KEY, { cluster: PUSHER_CLUSTER });
    const ch = pusher.subscribe("game-" + code);
    channelRef.current = ch;
    roomRef.current    = code;
    isHostRef.current  = hostMode;
    myNameRef.current  = name;

    ch.bind("player-joined", (data)=>{
      if (!isHostRef.current) return;
      const nameExists = Object.values(playersRef.current).some(p=>p.name.toLowerCase()===data.name.toLowerCase());
      if (nameExists) { emit(code, "name-taken", { targetId: data.id }); return; }
      const np = { ...playersRef.current, [data.id]:{ name:data.name, isHost:false } };
      const ns = { ...scoresRef.current,  [data.id]:0 };
      playersRef.current = np; scoresRef.current = ns;
      setPlayers(np); setScores(ns);
      setTwoPlayer(Object.keys(np).length===2);
      emit(code, "lobby-state", { players:np, scores:ns, config:cfg.current });
    });

    ch.bind("lobby-state", (data)=>{
      if (isHostRef.current) return;
      const merged = { ...data.players, [id]:{ name, isHost:false } };
      playersRef.current = merged; scoresRef.current = { ...data.scores, [id]:0 };
      setPlayers(merged); setScores({ ...data.scores, [id]:0 });
      cfg.current = data.config;
      setTwoPlayer(Object.keys(merged).length===2);
    });

    ch.bind("start-round", (data)=>{
      clearInterval(ansTimerRef.current); clearInterval(votTimerRef.current);
      roundRef.current = data.round; qRef.current = data.question;
      answersRef.current = {};
      resultsShownRef.current = false;
      cfg.current = { totalRounds:data.totalRounds, answerTime:data.answerTime, voteTime:data.voteTime };
      setRound(data.round); setQuestion(data.question);
      setAnswerText(""); setAnswerLocked(false); ansLockedRef.current = false;
      setSubCount(0); setMyVote(null); myVoteRef.current = null;
      setTwoPlayer(data.twoPlayer); setReactions([]);
      setIntroRound(data.round); setShowRoundIntro(true);
      setTimeout(()=>{ setShowRoundIntro(false); setScreen("answer"); startAnsTimer(data.answerTime); }, 1800);
    });

    ch.bind("answer-in", (data)=>{
      if (!isHostRef.current) return;
      if (answersRef.current[data.playerId]) return;
      const updated = { ...answersRef.current, [data.playerId]:{ text:data.text, authorId:data.playerId, authorName:data.playerName, _votes:[], submittedAt:data.submittedAt||Date.now() } };
      answersRef.current = updated;
      const count = Object.keys(updated).length;
      const total = Object.keys(playersRef.current).length;
      setSubCount(count);
      emit(code, "sub-count", { count, total });
      if (count >= total) { clearInterval(ansTimerRef.current); beginVoting(updated, code); }
    });

    ch.bind("sub-count", (data)=>{ setSubCount(data.count); });

    ch.bind("start-voting", (data)=>{
      clearInterval(ansTimerRef.current);
      answersRef.current = data.answers;
      setQuestion(data.question);
      const sh = Object.entries(data.answers).sort(()=>Math.random()-.5);
      setShuffled(sh); setMyVote(null); myVoteRef.current = null;
      setScreen("vote");
      startVotTimer(data.voteTime);
    });

    ch.bind("vote-in", (data)=>{
      if (!isHostRef.current) return;
      const ans = answersRef.current;
      if (!ans[data.votedFor]) return;
      const alreadyVoted = Object.values(ans).some(a=>a._votes?.includes(data.voterId));
      if (alreadyVoted) return;
      const updated = { ...ans };
      updated[data.votedFor] = { ...updated[data.votedFor], _votes:[...(updated[data.votedFor]._votes||[]), data.voterId] };
      answersRef.current = updated;
      const totalVotes = Object.values(updated).reduce((s,a)=>s+(a._votes?.length||0),0);
      if (totalVotes >= Object.keys(playersRef.current).length) {
        clearInterval(votTimerRef.current); finalizeVotes();
      }
    });

    ch.bind("show-results", (data)=>{
      if (resultsShownRef.current) return;
      resultsShownRef.current = true;
      clearInterval(votTimerRef.current);
      prevScoresRef.current = { ...scoresRef.current };
      const sortedByVotes = Object.entries(data.answers).sort((a,b)=>(b[1]._votes?.length||0)-(a[1]._votes?.length||0));
      const roundWinnerId = sortedByVotes[0]?.[0];
      if (roundWinnerId) setStreaks(s=>{ const ns={}; Object.keys(data.scores).forEach(pid=>{ ns[pid]=pid===roundWinnerId?(s[pid]||0)+1:0; }); return ns; });
      scoresRef.current = data.scores;
      setScores(data.scores);
      setResults({ answers:data.answers, scores:data.scores, question:data.question });
      allResultsRef.current.push({ question:data.question, answers:data.answers });
      if(soundOn) playSound("reveal");
      const sortedA = Object.values(data.answers).sort((a,b)=>(b._votes?.length||0)-(a._votes?.length||0));
      if (sortedA.length>0 && (sortedA[0]._votes?.length||0)>0) {
        setSpotlightWinner(sortedA[0]); setShowSpotlight(true);
      } else { setScreen("results"); }
    });

    ch.bind("show-final", (data)=>{
      scoresRef.current = data.scores;
      setScores(data.scores);
      setResults(prev=>({ ...prev, scores:data.scores }));
      // Build recap
      buildRecap(data.scores);
      setScreen("final");
    });

    ch.bind("player-left", (data)=>{
      // Fix 1&2: Show player left message
      const leavingName = data.name || "A player";
      if (data.isHost) {
        // Fix 1: Host left — end game for everyone
        setHostLeft(true);
        clearInterval(ansTimerRef.current);
        clearInterval(votTimerRef.current);
        return;
      }
      setPlayerLeftMsg(`${leavingName} has left the game`);
      setTimeout(()=>setPlayerLeftMsg(null), 3000);

      const np = { ...playersRef.current };
      delete np[data.id];
      playersRef.current = np;
      setPlayers({...np});
      setTwoPlayer(Object.keys(np).length===2);
      if (!isHostRef.current) return;
      const remaining = Object.keys(np).length;
      if (remaining === 0) return;
      const currentAnswers = answersRef.current;

      // Check which phase we're in:
      // Answer phase = not all remaining players have answered yet
      // Vote phase = answers exist for everyone (or we already moved to vote screen)
      const realAnswerCount = Object.keys(currentAnswers).filter(pid => np[pid] || pid===data.id).length;
      const wasInAnswerPhase = realAnswerCount < Object.keys({ ...np, [data.id]: true }).length;

      if (wasInAnswerPhase) {
        if (!currentAnswers[data.id]) {
          // Leaver hadn't answered — DON'T add a blank yet (that's what caused the bug).
          // Just update the expected total so remaining players' count is correct.
          // The blank will be added right before voting starts.
          const realCount = Object.keys(np).filter(pid => currentAnswers[pid]).length;
          emit(code, "sub-count", { count: realCount, total: remaining });
          setSubCount(realCount);
          // Check if all REMAINING (non-leaver) players have now answered
          const allRemainingAnswered = Object.keys(np).every(pid => currentAnswers[pid]);
          if (allRemainingAnswered && remaining > 0) {
            // Now add blank for leaver and start voting
            const updated = { ...currentAnswers, [data.id]:{ text:"(left)", authorId:data.id, authorName:data.name, _votes:[] } };
            answersRef.current = updated;
            clearInterval(ansTimerRef.current);
            beginVoting(updated, code);
          }
        } else {
          // Leaver had answered — check if remaining players all answered
          const allRemainingAnswered = Object.keys(np).every(pid => currentAnswers[pid]);
          if (allRemainingAnswered && remaining > 0) {
            clearInterval(ansTimerRef.current);
            beginVoting(currentAnswers, code);
          }
        }
      } else {
        // Vote phase — check if remaining players all voted
        const totalVotes = Object.keys(np).filter(pid =>
          Object.values(answersRef.current).some(a => a._votes?.includes(pid))
        ).length;
        if (totalVotes >= remaining) { clearInterval(votTimerRef.current); finalizeVotes(); }
      }
    });

    // Fix 1: host-ended event — received by guests when host force-ends
    ch.bind("host-ended", ()=>{
      setHostLeft(true);
      clearInterval(ansTimerRef.current);
      clearInterval(votTimerRef.current);
    });

    // Kick player (host only sends, target leaves)
    ch.bind("kicked", (data)=>{
      if (data.targetId !== id) return;
      showToast("You were kicked by the host 👢", 3000);
      goHome(true);
    });

    // Player kicked notify others
    ch.bind("player-kicked", (data)=>{
      const np = { ...playersRef.current };
      delete np[data.id];
      playersRef.current = np;
      setPlayers({...np});
    });

    // Reactions
    ch.bind("reaction", (data)=>{
      setReactions(prev=>[...prev.slice(-9), { ...data, ts:Date.now() }]);
      setTimeout(()=>setReactions(prev=>prev.filter(r=>r.ts!==data.ts)), 4000);
      const e=(data.emoji||"").split(" ")[0]; if(e) spawnRain(e, 5);
    });

    ch.bind("name-taken", (data)=>{
      if (data.targetId !== id) return;
      onNameTaken();
    });

    // Fix 6: host restarted — non-host guests go back to lobby
    ch.bind("host-restarted", (data)=>{
      if (isHostRef.current) return;
      // Merge existing player data with fresh scores
      const merged = { ...data.players, [id]:{ name, isHost:false } };
      playersRef.current = merged;
      scoresRef.current = { ...data.scores, [id]:0 };
      setPlayers(merged); setScores({ ...data.scores, [id]:0 });
      cfg.current = data.config;
      usedQ.current=[]; roundRef.current=0; answersRef.current={};
      allResultsRef.current=[];
      setRound(0); setResults({ answers:{}, scores:{}, question:"" });
      setAnswerText(""); setAnswerLocked(false); ansLockedRef.current=false;
      myVoteRef.current=null; setMyVote(null); setSubCount(0);
      setRoundRecap(null); setReactions([]);
      setHostLeft(false); setWaitingRejoin(false);
      setScreen("lobby");
    });

    return ch;
  }

  function buildRecap(finalScores) {
    const recap = {
      mostVotes:  null,
      mostChaos:  null,
      mvp:        null,
    };
    let maxVotes = 0; let maxChaosQ = "";
    allResultsRef.current.forEach(r=>{
      Object.values(r.answers).forEach(a=>{
        const v = a._votes?.length||0;
        if (v > maxVotes) { maxVotes = v; recap.mostVotes = { ...a, question: r.question, votes: v }; }
      });
      // Most chaotic = question with most spread of votes
      const votesSorted = Object.values(r.answers).map(a=>a._votes?.length||0).sort((a,b)=>b-a);
      if (votesSorted.length>1 && votesSorted[0]===votesSorted[1]) maxChaosQ = r.question;
    });
    if (maxChaosQ) recap.mostChaos = maxChaosQ;
    // MVP = highest scorer
    const sorted = Object.entries(finalScores).sort((a,b)=>b[1]-a[1]);
    if (sorted.length>0) recap.mvp = { id: sorted[0][0], pts: sorted[0][1] };
    setRoundRecap(recap);
  }

  function beginVoting(answers, code) {
    emit(code, "start-voting", { answers, question:qRef.current, voteTime:cfg.current.voteTime });
    const sh = Object.entries(answers).sort(()=>Math.random()-.5);
    setShuffled(sh); setMyVote(null); myVoteRef.current = null;
    setScreen("vote");
    startVotTimer(cfg.current.voteTime);
  }

  function finalizeVotes() {
    if (resultsShownRef.current) return;
    resultsShownRef.current = true;
    const ans = answersRef.current;
    prevScoresRef.current = { ...scoresRef.current };
    const ns  = { ...scoresRef.current };
    Object.entries(ans).forEach(([id,a])=>{ ns[id]=(ns[id]||0)+(a._votes?.length||0); });
    scoresRef.current = ns;
    const payload = { answers:ans, scores:ns, question:qRef.current };
    emit(roomRef.current, "show-results", payload);
    const sortedByVotes = Object.entries(ans).sort((a,b)=>(b[1]._votes?.length||0)-(a[1]._votes?.length||0));
    const roundWinnerId = sortedByVotes[0]?.[0];
    if (roundWinnerId) setStreaks(s=>{ const ns2={}; Object.keys(ns).forEach(pid=>{ ns2[pid]=pid===roundWinnerId?(s[pid]||0)+1:0; }); return ns2; });
    setScores(ns); setResults(payload);
    allResultsRef.current.push({ question:qRef.current, answers:ans });
    if(soundOn) playSound("reveal");
    const sortedA = Object.values(ans).sort((a,b)=>(b._votes?.length||0)-(a._votes?.length||0));
    if (sortedA.length>0 && (sortedA[0]._votes?.length||0)>0) {
      setSpotlightWinner(sortedA[0]); setShowSpotlight(true);
    } else { setScreen("results"); }
  }

  function submitAnswer(text) {
    if (ansLockedRef.current) return;
    ansLockedRef.current = true;
    setAnswerLocked(true);
    if(soundOn) playSound("lock");
    emit(roomRef.current, "answer-in", { playerId:myId, playerName:myNameRef.current, text: text || answerText.trim() || "(passed)", submittedAt: Date.now() });
  }

  function castVote(targetId) {
    if (myVoteRef.current) return;
    const isSelf = targetId===myId;
    const tp = Object.keys(playersRef.current).length===2;
    if (isSelf && !tp) return;
    myVoteRef.current = targetId;
    setMyVote(targetId);
    if(soundOn) playSound("lock");
    if (!isHostRef.current) clearInterval(votTimerRef.current);
    emit(roomRef.current, "vote-in", { voterId:myId, votedFor:targetId });
  }

  function sendReaction(emoji) {
    const now = Date.now();
    if (now - lastReactionRef.current < 3000) {
      showToast("⏳ Wait 3 seconds between messages!", 1500);
      return;
    }
    lastReactionRef.current = now;
    emit(roomRef.current, "reaction", { id:myId, name:myNameRef.current, emoji });
    spawnRain(emoji.split(" ")[0]||emoji, 6);
  }

  function kickPlayer(playerId) {
    if (!window.confirm(`Kick ${players[playerId]?.name}?`)) return;
    emit(roomRef.current, "kicked", { targetId: playerId });
    emit(roomRef.current, "player-kicked", { id: playerId });
    const np = { ...playersRef.current };
    delete np[playerId];
    playersRef.current = np;
    setPlayers({...np});
  }

  function doNextRound() {
    const next = roundRef.current+1;
    if (roundRef.current === 0) {
      fetch(`${SERVER}/room-status`, { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ code: roomRef.current, status: "ongoing" }) });
    }
    if (next>cfg.current.totalRounds) {
      emit(roomRef.current, "show-final", { scores:scoresRef.current });
      buildRecap(scoresRef.current);
      setScreen("final");
      return;
    }
    const available = QUESTIONS.filter((_,i)=>!usedQ.current.includes(i));
    const pick = Math.floor(Math.random()*available.length);
    const realIdx = QUESTIONS.indexOf(available[pick]);
    usedQ.current.push(realIdx);
    roundRef.current = next; qRef.current = available[pick]; answersRef.current = {};
    const tp = Object.keys(playersRef.current).length===2;
    emit(roomRef.current, "start-round", { round:next, question:available[pick], totalRounds:cfg.current.totalRounds, answerTime:cfg.current.answerTime, voteTime:cfg.current.voteTime, twoPlayer:tp });
    setRound(next); setQuestion(available[pick]);
    setAnswerText(""); setAnswerLocked(false); ansLockedRef.current = false;
    setSubCount(0); setMyVote(null); myVoteRef.current = null;
    setTwoPlayer(tp); setReactions([]);
    setIntroRound(next); setShowRoundIntro(true);
    setTimeout(()=>{ setShowRoundIntro(false); setScreen("answer"); startAnsTimer(cfg.current.answerTime); }, 1800);
  }

  function spawnParticles(x, y) {
    const cols=["#ff4d6d","#ffd60a","#4cc9f0","#7b2ff7","#4ade80","#ff8c00"];
    const newP=Array.from({length:20},(_,i)=>({ id:Date.now()+i, x, y, size:4+Math.random()*8, color:cols[Math.floor(Math.random()*cols.length)], dx:(Math.random()-0.5)*200, dy:(Math.random()-0.5)*200-80, dur:500+Math.random()*400 }));
    setParticles(p=>[...p,...newP]);
    setTimeout(()=>setParticles(p=>p.filter(pp=>!newP.some(n=>n.id===pp.id))), 1000);
  }

  function spawnRain(emoji, count=8) {
    const newDrops=Array.from({length:count},(_,i)=>({ id:Date.now()+i, emoji, left:5+Math.random()*88+'vw', dur:2200+Math.random()*1800, delay:Math.random()*700 }));
    setRainDrops(d=>[...d,...newDrops]);
    setTimeout(()=>setRainDrops(d=>d.filter(dd=>!newDrops.some(n=>n.id===dd.id))), 5000);
  }

  function hostGame(name, rounds, aTime, vTime) {
    if (!name.trim()) return showToast("Enter a nickname!");
    const code = genCode();
    cfg.current = { totalRounds:rounds, answerTime:aTime, voteTime:vTime };
    myNameRef.current = name; isHostRef.current = true;
    setMyName(name); setIsHost(true); setRoomCode(code);
    const ip = { [myId]:{ name, isHost:true } };
    const is = { [myId]:0 };
    playersRef.current = ip; scoresRef.current = is;
    setPlayers(ip); setScores(is); allResultsRef.current = [];
    fetch(`${SERVER}/create-room`, { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ code }) });
    setupPusher(code, true, myId, name, ()=>{});
    setScreen("lobby");
  }

  async function joinGame(name, code) {
    if (!name.trim()) return showToast("Enter a nickname!");
    if (code.trim().length<3) return showToast("Enter a valid room code!");
    const upper = code.toUpperCase();
    setJoining(true);
    try {
      const res = await fetch(`${SERVER}/room-exists?code=${upper}`);
      const { exists, status } = await res.json();
      if (!exists) { setJoining(false); return showToast("❌ Room not found! Check the code.", 3000); }
      if (status === "ongoing") { setJoining(false); return showToast("🎮 Game ongoing — wait for it to end!", 3000); }
    } catch(e) { setJoining(false); return showToast("⚠️ Can't reach server. Is it running?", 3000); }
    myNameRef.current = name; isHostRef.current = false;
    setMyName(name); setIsHost(false); setRoomCode(upper);
    allResultsRef.current = [];
    const ch = setupPusher(upper, false, myId, name, ()=>{ showToast("❌ Name already taken!", 3000); goHome(true); });
    ch.bind("pusher:subscription_succeeded", ()=>{ emit(upper, "player-joined", { id:myId, name }); });
    setJoining(false); setScreen("lobby");
    showToast("Joined! Waiting for others...");
  }

  function goHome(skipConfirm=false) {
    if (!skipConfirm && screen !== "home") {
      if (!window.confirm("Are you sure you want to leave?")) return;
    }
    clearInterval(ansTimerRef.current); clearInterval(votTimerRef.current);
    if (roomRef.current) {
      // Fix 1&4: if host leaves, notify everyone and delete room
      if (isHostRef.current) {
        emit(roomRef.current, "host-ended", {});
        emit(roomRef.current, "player-left", { id:myId, name:myNameRef.current, isHost:true });
        // Fix 4: delete room so no one can join dead room
        fetch(`${SERVER}/delete-room`, { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ code: roomRef.current }) });
      } else {
        emit(roomRef.current, "player-left", { id:myId, name:myNameRef.current, isHost:false });
      }
    }
    if (channelRef.current) { channelRef.current.unbind_all(); channelRef.current.pusher?.disconnect(); channelRef.current = null; }
    setScreen("home"); setPlayers({}); setScores({}); setRound(0); setQuestion("");
    setAnswerText(""); setAnswerLocked(false); setMyVote(null);
    setShuffled([]); setResults({ answers:{}, scores:{}, question:"" });
    setRoundRecap(null); setReactions([]); setShowSpotlight(false);
    setHostLeft(false); setPlayerLeftMsg(null); setWaitingRejoin(false);
    playersRef.current={}; scoresRef.current={}; answersRef.current={};
    usedQ.current=[]; roundRef.current=0; qRef.current=""; roomRef.current="";
    ansLockedRef.current=false; myVoteRef.current=null; allResultsRef.current=[];
  }

  function playAgain() {
    usedQ.current=[]; roundRef.current=0; answersRef.current={};
    allResultsRef.current=[];
    const rs={};
    Object.keys(scoresRef.current).forEach(id=>{ rs[id]=0; });
    scoresRef.current=rs; setScores(rs);
    setRound(0); setResults({ answers:{}, scores:{}, question:"" });
    setAnswerText(""); setAnswerLocked(false); ansLockedRef.current=false;
    myVoteRef.current=null; setMyVote(null); setSubCount(0);
    setRoundRecap(null); setReactions([]);
    // Fix 7: re-register room so NEW players can join
    fetch(`${SERVER}/create-room`, { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ code: roomRef.current }) });
    fetch(`${SERVER}/room-status`, { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ code: roomRef.current, status: "lobby" }) });
    // Fix 6: notify guests that host has restarted — they can rejoin lobby
    emit(roomRef.current, "host-restarted", { players: playersRef.current, scores: rs, config: cfg.current });
    setScreen("lobby");
  }

  const playerCount = Object.keys(players).length;

  // Spotlight transition
  if (showRoundIntro) {
    return <RoundIntro round={introRound} total={cfg.current.totalRounds} />;
  }

  if (showSpotlight && spotlightWinner) {
    return <SpotlightScreen winner={spotlightWinner} onDone={()=>{ setShowSpotlight(false); setScreen("results"); }} />;
  }

  // Fix 1: Host left screen
  if (hostLeft) {
    return (
      <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
        <div style={{ textAlign:"center", maxWidth:360 }}>
          <div style={{ fontSize:"3rem", marginBottom:16 }}>😢</div>
          <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:"1.6rem", fontWeight:800, marginBottom:12 }}>Host has left the game</h2>
          <p style={{ color:C.muted, marginBottom:28, fontSize:"0.95rem" }}>Please create a new room to play again.</p>
          <Btn onClick={()=>goHome(true)}>Back to Home</Btn>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="ad-slot" id="ad-top" aria-hidden="true" />

      {screen==="home"    && <HomeScreen    tab={tab} setTab={setTab} onHost={hostGame} onJoin={joinGame} joining={joining} soundOn={soundOn} setSoundOn={setSoundOn} />}
      {screen==="lobby"   && <LobbyScreen   roomCode={roomCode} players={players} isHost={isHost} canStart={playerCount>=2} onStart={doNextRound} cfg={cfg.current} onLeave={goHome} myId={myId} onKick={kickPlayer} />}
      {screen==="answer"  && <AnswerScreen  question={question} round={round} total={cfg.current.totalRounds} answerText={answerText} setAnswerText={setAnswerText} locked={answerLocked} onSubmit={(e)=>{ spawnParticles(e?.clientX||window.innerWidth/2, e?.clientY||window.innerHeight/2); submitAnswer(answerText.trim()); }} timer={ansTimer} totalTime={cfg.current.answerTime} subCount={subCount} totalPlayers={playerCount} onLeave={goHome} roomCode={roomCode} reactions={reactions} onReact={sendReaction} soundOn={soundOn} spawnRain={spawnRain} />}
      {screen==="vote"    && <VoteScreen    question={question} round={round} total={cfg.current.totalRounds} shuffled={shuffled} myId={myId} myVote={myVote} onVote={(id,e)=>{ spawnParticles(e?.clientX||window.innerWidth/2, e?.clientY||window.innerHeight/2); castVote(id); }} timer={votTimer} totalTime={cfg.current.voteTime} twoPlayer={twoPlayer} onLeave={goHome} roomCode={roomCode} soundOn={soundOn} />}
      {screen==="results" && <ResultsScreen snap={results} players={players} round={round} total={cfg.current.totalRounds} isHost={isHost} onNext={doNextRound} onLeave={goHome} myId={myId} streaks={streaks} prevScores={prevScoresRef.current} />}
      {screen==="final"   && <FinalScreen   scores={results.scores} players={players} answers={results.answers} onPlayAgain={playAgain} onLeave={goHome} myId={myId} isHost={isHost} recap={roundRecap} roomCode={roomCode} />}

      <div className="ad-slot" id="ad-bottom" aria-hidden="true" />

      {/* Fix 2: player left message */}
      {playerLeftMsg && (
        <div className="fadeUp" style={{ position:"fixed", top:20, left:"50%", transform:"translateX(-50%)", background:C.surface2, border:`1px solid ${C.border}`, borderRadius:50, padding:"8px 18px", fontSize:"0.84rem", zIndex:999, whiteSpace:"nowrap", color:C.muted }}>
          👋 {playerLeftMsg}
        </div>
      )}

      {toast && (
        <div className="fadeUp" style={{ position:"fixed", bottom:26, left:"50%", transform:"translateX(-50%)", background:C.surface2, border:`1px solid ${C.border}`, borderRadius:50, padding:"9px 20px", fontSize:"0.87rem", zIndex:998, whiteSpace:"nowrap" }}>
          {toast}
        </div>
      )}
      <FeedbackButton />
      <CoffeeButton />
      <ParticleBurst particles={particles} />
      <ReactionRain drops={rainDrops} />
    </>
  );
}

// ─── Feedback Button ──────────────────────────────────────────
function FeedbackButton() {
  const [open, setOpen]     = useState(false);
  const [text, setText]     = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent]     = useState(false);

  async function send() {
    if (!text.trim()) return;
    setSending(true);
    try {
      await fetch(`${SERVER}/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: text.trim() }),
      });
      setSent(true);
      setText("");
      setTimeout(() => { setSent(false); setOpen(false); }, 2000);
    } catch(e) {}
    setSending(false);
  }

  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          position:"fixed", bottom:20, right:20, zIndex:500,
          background:C.surface2, border:`1px solid ${C.border}`,
          borderRadius:50, padding:"8px 14px", cursor:"pointer",
          color:C.muted, fontSize:"0.8rem", display:"flex",
          alignItems:"center", gap:6, boxShadow:"0 4px 20px rgba(0,0,0,.4)",
          transition:"all .2s",
        }}
        onMouseEnter={e=>e.currentTarget.style.borderColor=C.cyan}
        onMouseLeave={e=>e.currentTarget.style.borderColor=C.border}
      >
        💬 Feedback
      </button>

      {/* Modal */}
      {open && (
        <div style={{
          position:"fixed", inset:0, zIndex:600,
          display:"flex", alignItems:"flex-end", justifyContent:"flex-end",
          padding:"0 20px 70px", pointerEvents:"none",
        }}>
          <div className="pop" style={{
            background:C.surface, border:`1px solid ${C.border}`,
            borderRadius:20, padding:20, width:"100%", maxWidth:320,
            pointerEvents:"all", boxShadow:"0 8px 40px rgba(0,0,0,.5)",
          }}>
            <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, marginBottom:4, fontSize:"0.95rem" }}>
              Got a suggestion? 💡
            </div>
            <div style={{ color:C.muted, fontSize:"0.78rem", marginBottom:12 }}>
              Tell us what you'd improve — we read every message.
            </div>
            {sent ? (
              <div style={{ textAlign:"center", padding:"16px 0", color:"#4ade80", fontWeight:600 }}>
                ✅ Sent! Thanks for the feedback.
              </div>
            ) : (
              <>
                <textarea
                  value={text}
                  onChange={e => setText(e.target.value)}
                  placeholder="e.g. Add a dark horse round, fix the timer..."
                  maxLength={500}
                  style={{
                    width:"100%", padding:"10px 12px", background:C.surface2,
                    border:`1px solid ${C.border}`, borderRadius:12,
                    color:C.text, fontSize:"0.88rem", outline:"none",
                    resize:"none", minHeight:90, marginBottom:8,
                    fontFamily:"'Outfit',sans-serif",
                  }}
                  onFocus={e=>e.target.style.borderColor=C.cyan}
                  onBlur={e=>e.target.style.borderColor=C.border}
                />
                <div style={{ display:"flex", gap:8 }}>
                  <button
                    onClick={() => setOpen(false)}
                    style={{ flex:1, padding:"9px", borderRadius:50, background:"transparent", border:`1px solid ${C.border}`, color:C.muted, cursor:"pointer", fontFamily:"'Outfit',sans-serif", fontSize:"0.85rem" }}
                  >Cancel</button>
                  <button
                    onClick={send}
                    disabled={sending || !text.trim()}
                    style={{ flex:2, padding:"9px", borderRadius:50, background:C.accent, border:"none", color:"#fff", cursor:sending||!text.trim()?"not-allowed":"pointer", fontFamily:"'Outfit',sans-serif", fontWeight:600, fontSize:"0.85rem", opacity:sending||!text.trim()?0.5:1 }}
                  >{sending ? "Sending..." : "Send 🚀"}</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

// ── Particle Burst ────────────────────────────────────────────
function ParticleBurst({ particles }) {
  return (
    <>
      {particles.map(p=>(
        <div key={p.id} className="particle" style={{ left:p.x, top:p.y, width:p.size, height:p.size, background:p.color, '--dx':p.dx+'px', '--dy':p.dy+'px', animationDuration:p.dur+'ms' }} />
      ))}
    </>
  );
}

// ── Reaction Rain ──────────────────────────────────────────────
function ReactionRain({ drops }) {
  return (
    <>
      {drops.map(d=>(
        <div key={d.id} className="reaction-rain-drop" style={{ left:d.left, animationDuration:d.dur+'ms', animationDelay:d.delay+'ms' }}>{d.emoji}</div>
      ))}
    </>
  );
}

// ── Round Intro ────────────────────────────────────────────────
function RoundIntro({ round, total }) {
  return (
    <div className="round-intro-overlay">
      <div style={{ textAlign:"center" }}>
        <div style={{ fontSize:"0.85rem", fontWeight:700, letterSpacing:5, color:"rgba(255,255,255,0.35)", textTransform:"uppercase", marginBottom:16 }}>Get Ready</div>
        <div className="grad-text" style={{ fontFamily:"'Syne',sans-serif", fontSize:"clamp(5rem,18vw,10rem)", fontWeight:900, lineHeight:0.9 }}>{round}</div>
        <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"clamp(0.9rem,2.5vw,1.2rem)", fontWeight:700, color:"rgba(255,255,255,0.3)", marginTop:16, letterSpacing:3 }}>ROUND OF {total}</div>
      </div>
    </div>
  );
}

// ── Buy Me a Coffee ────────────────────────────────────────────
function CoffeeButton() {
  const [expanded, setExpanded] = useState(false);
  const isMobile = typeof window !== "undefined" && window.matchMedia("(hover:none)").matches;
  if (isMobile) {
    return (
      <div className="coffee-btn" style={{ userSelect:"none" }}
        onClick={()=>{ if(expanded) window.open("https://www.paypal.com/ncp/payment/AJKD3CRLUBQWS","_blank"); else setExpanded(true); }}>
        <span className="coffee-emoji">☕</span>
        <span className="coffee-label" style={{ maxWidth:expanded?"140px":"0", opacity:expanded?1:0, marginLeft:expanded?8:0 }}>Buy me a coffee</span>
      </div>
    );
  }
  return (
    <a href="https://www.paypal.com/ncp/payment/AJKD3CRLUBQWS" target="_blank" rel="noopener noreferrer" className="coffee-btn">
      <span className="coffee-emoji">☕</span>
      <span className="coffee-label">Buy me a coffee</span>
    </a>
  );
}

// ─── Screens ──────────────────────────────────────────────────

function HomeScreen({ tab, setTab, onHost, onJoin, joining, soundOn, setSoundOn }) {
  const [hName,setHName]=useState(""); const [jName,setJName]=useState(""); const [jCode,setJCode]=useState("");
  const [rounds,setRounds]=useState(5); const [aTime,setATime]=useState(45); const [vTime,setVTime]=useState(30);
  const [showRules, setShowRules] = useState(false);
  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ width:"100%", maxWidth:450 }}>
        <div style={{ textAlign:"center", marginBottom:28, position:"relative" }}>
          <h1 className="grad-text" style={{ fontFamily:"'Syne',sans-serif", fontSize:"clamp(2.5rem,7vw,3.8rem)", fontWeight:900, lineHeight:1.05, marginBottom:8 }}>Yap 🗣️<br/>Wars</h1>
          <p style={{ color:C.muted, fontSize:"0.92rem" }}>Answer wild questions · Vote · Win glory</p>
          <button onClick={()=>setShowRules(true)} style={{ marginTop:10, background:"transparent", border:`1px solid ${C.border}`, borderRadius:50, padding:"4px 12px", color:C.muted, cursor:"pointer", fontSize:"0.78rem", display:"inline-flex", alignItems:"center", gap:5, transition:"all .18s" }}
            onMouseEnter={e=>{e.currentTarget.style.borderColor=C.cyan;e.currentTarget.style.color=C.cyan}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.color=C.muted}}>
            ℹ️ How to Play
          </button>
        </div>

        {/* Rules Modal */}
        {showRules && (
          <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.75)", zIndex:700, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }} onClick={()=>setShowRules(false)}>
            <div className="pop" style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:20, padding:28, maxWidth:440, width:"100%", maxHeight:"80vh", overflowY:"auto" }} onClick={e=>e.stopPropagation()}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
                <h2 style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:"1.3rem" }}>How to Play 🔥</h2>
                <button onClick={()=>setShowRules(false)} style={{ background:"transparent", border:"none", color:C.muted, cursor:"pointer", fontSize:"1.2rem" }}>✕</button>
              </div>
              {[
                { icon:"🎮", title:"Host or Join", desc:"One person creates a room and shares the 4-letter code with friends. Everyone joins with the code and a nickname." },
                { icon:"❓", title:"Answer the Question", desc:"Each round, a wild question appears. Type your funniest, most creative answer in 10 words or less before the timer runs out." },
                { icon:"🗳️", title:"Vote for the Best", desc:"All answers are shown anonymously — shuffled so no one knows who wrote what. Pick the one you like most. You can't vote for yourself (unless it's just 2 players!)." },
                { icon:"🏆", title:"Score Points", desc:"Every vote your answer receives = 1 point. The player with the most points after all rounds wins!" },
                { icon:"⚡", title:"Tiebreaker", desc:"If two players have the same score, whoever submitted their answers faster wins the tiebreak." },
                { icon:"📜", title:"Rules", desc:"Be creative, be funny, keep it civil. Answers must be 10 words or less. If you don't answer in time, a blank is submitted for you." },
              ].map(({icon,title,desc})=>(
                <div key={title} style={{ display:"flex", gap:14, marginBottom:18 }}>
                  <div style={{ fontSize:"1.4rem", flexShrink:0, marginTop:2 }}>{icon}</div>
                  <div>
                    <div style={{ fontWeight:600, marginBottom:3, fontSize:"0.92rem" }}>{title}</div>
                    <div style={{ color:C.muted, fontSize:"0.82rem", lineHeight:1.5 }}>{desc}</div>
                  </div>
                </div>
              ))}
              <button onClick={()=>setShowRules(false)} style={{ width:"100%", marginTop:4, padding:"11px", borderRadius:50, background:C.accent, border:"none", color:"#fff", cursor:"pointer", fontFamily:"'Outfit',sans-serif", fontWeight:600, fontSize:"0.9rem" }}>
                Got it! Let's Play 🚀
              </button>
            </div>
          </div>
        )}
        <div style={{ display:"flex", gap:8, marginBottom:14 }}>
          {["host","join"].map(t=>(
            <button key={t} onClick={()=>setTab(t)} style={{ flex:1, padding:"10px", borderRadius:12, fontFamily:"'Outfit',sans-serif", border:`1px solid ${tab===t?C.accent:C.border}`, background:tab===t?"rgba(255,77,109,.12)":"transparent", color:tab===t?C.accent:C.muted, cursor:"pointer", fontWeight:600, fontSize:"0.88rem", transition:"all .18s" }}>
              {t==="host"?"🎮 Host a Game":"🚀 Join a Game"}
            </button>
          ))}
        </div>
        <Card className="fadeUp">
          {tab==="host" ? (
            <>
              <div style={{ marginBottom:16 }}>
                <div style={{ fontSize:"0.8rem", color:C.muted, marginBottom:5, fontWeight:500 }}>Your Nickname</div>
                <input style={iStyle} value={hName} onChange={e=>setHName(e.target.value)} placeholder="e.g. ChaosKing" maxLength={16} onFocus={e=>e.target.style.borderColor=C.cyan} onBlur={e=>e.target.style.borderColor=C.border} />
              </div>
              <div style={{ display:"flex", gap:10, marginBottom:16 }}>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:"0.8rem", color:C.muted, marginBottom:5, fontWeight:500 }}>Rounds</div>
                  <select style={iStyle} value={rounds} onChange={e=>setRounds(+e.target.value)}>{[3,5,7,10].map(n=><option key={n} value={n}>{n} rounds</option>)}</select>
                </div>
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:"0.8rem", color:C.muted, marginBottom:5, fontWeight:500 }}>Answer Time</div>
                  <select style={iStyle} value={aTime} onChange={e=>setATime(+e.target.value)}>{[30,45,60].map(n=><option key={n} value={n}>{n}s</option>)}</select>
                </div>
              </div>
              <div style={{ marginBottom:20 }}>
                <div style={{ fontSize:"0.8rem", color:C.muted, marginBottom:5, fontWeight:500 }}>Vote Time</div>
                <select style={iStyle} value={vTime} onChange={e=>setVTime(+e.target.value)}>{[20,30,45].map(n=><option key={n} value={n}>{n}s</option>)}</select>
              </div>
              <Btn onClick={()=>onHost(hName,rounds,aTime,vTime)}>Create Room 🎲</Btn>
            </>
          ) : (
            <>
              <div style={{ marginBottom:16 }}>
                <div style={{ fontSize:"0.8rem", color:C.muted, marginBottom:5, fontWeight:500 }}>Your Nickname</div>
                <input style={iStyle} value={jName} onChange={e=>setJName(e.target.value)} placeholder="e.g. WildCard" maxLength={16} onFocus={e=>e.target.style.borderColor=C.cyan} onBlur={e=>e.target.style.borderColor=C.border} />
              </div>
              <div style={{ marginBottom:20 }}>
                <div style={{ fontSize:"0.8rem", color:C.muted, marginBottom:5, fontWeight:500 }}>Room Code</div>
                <input style={{ ...iStyle, textTransform:"uppercase", letterSpacing:8, fontSize:"1.5rem", fontWeight:700, textAlign:"center" }} value={jCode} onChange={e=>setJCode(e.target.value.toUpperCase())} onKeyDown={e=>e.key==="Enter"&&onJoin(jName,jCode)} placeholder="XXXX" maxLength={6} onFocus={e=>e.target.style.borderColor=C.cyan} onBlur={e=>e.target.style.borderColor=C.border} />
              </div>
              <Btn onClick={()=>onJoin(jName,jCode)} disabled={joining}>{joining?"Checking room...":"Join Room 🚀"}</Btn>
            </>
          )}
        </Card>
        {/* Sound toggle */}
        <div style={{ textAlign:"center", marginTop:16 }}>
          <button onClick={()=>setSoundOn(s=>!s)} style={{ background:"transparent", border:"none", color:C.muted, cursor:"pointer", fontSize:"0.82rem", gap:6, display:"inline-flex", alignItems:"center" }}>
            {soundOn?"🔊":"🔇"} Sound {soundOn?"On":"Off"}
          </button>
        </div>
        <p style={{paddingTop:"20px", textAlign:"center", color:C.muted, fontSize:"0.72rem" }}>
          © 2026 Yap Wars. All rights reserved.
        </p>
      </div>
    </div>
  );
}

function LobbyScreen({ roomCode, players, isHost, canStart, onStart, cfg, onLeave, myId, onKick }) {
  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ width:"100%", maxWidth:440 }}>
        <div style={{ textAlign:"center", marginBottom:20 }}>
          <div style={{ fontSize:"0.72rem", fontWeight:600, letterSpacing:2, color:C.accent, textTransform:"uppercase", marginBottom:10 }}>WAITING FOR PLAYERS</div>
          <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:"1.9rem", fontWeight:800 }}>Game Lobby</h2>
        </div>
        <div style={{ background:C.surface, border:`2px dashed rgba(255,214,10,.35)`, borderRadius:18, padding:"16px 20px", marginBottom:14, textAlign:"center" }}>
          <div style={{ fontSize:"0.72rem", color:C.muted, fontWeight:500, marginBottom:6, letterSpacing:1 }}>ROOM CODE</div>
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:"3rem", fontWeight:900, letterSpacing:14, color:C.yellow }}>{roomCode}</div>
        </div>
        <Card>
          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:12 }}>
            <span style={{ fontWeight:600 }}>Players</span>
            <span style={{ color:C.muted, fontSize:"0.82rem" }}>{Object.keys(players).length} joined</span>
          </div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:7, marginBottom:16 }}>
            {Object.entries(players).map(([id,p])=>(
              <div key={id} style={{ display:"flex", alignItems:"center", gap:4 }}>
                <div className={`chip${p.isHost?" host":""}`}>
                  <span style={{ width:7, height:7, borderRadius:"50%", background:"#4ade80", flexShrink:0 }} />
                  {p.name}{p.isHost?" 👑":""}
                </div>
                {/* Kick button — only host sees, not for themselves */}
                {isHost && id!==myId && (
                  <button onClick={()=>onKick(id)} style={{ background:"transparent", border:"none", cursor:"pointer", color:C.muted, fontSize:"0.75rem", padding:"2px 4px" }} title="Kick player">✕</button>
                )}
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:7, marginBottom:18, flexWrap:"wrap" }}>
            {[`${cfg.totalRounds} rounds`,`${cfg.answerTime}s answer`,`${cfg.voteTime}s vote`].map(t=>(
              <div key={t} style={{ padding:"3px 10px", borderRadius:50, fontSize:"0.73rem", background:C.surface3, color:C.muted, border:`1px solid ${C.border}` }}>{t}</div>
            ))}
          </div>
          {isHost
            ? <Btn onClick={onStart} disabled={!canStart}>{canStart?"Start Game! 🔥":"Need 2+ players..."}</Btn>
            : <p className="pulse" style={{ textAlign:"center", color:C.muted, fontSize:"0.9rem", padding:"12px 0" }}>Waiting for host to start...</p>
          }
          <button onClick={onLeave} style={{ marginTop:10, width:"100%", background:"transparent", border:"none", color:C.muted, fontSize:"0.82rem", cursor:"pointer", padding:"8px" }}>← Leave Room</button>
        </Card>
      </div>
    </div>
  );
}

// Reaction bubbles overlay
function ReactionBubbles({ reactions }) {
  return (
    <div style={{ position:"fixed", bottom:80, right:16, display:"flex", flexDirection:"column-reverse", gap:6, zIndex:50, pointerEvents:"none" }}>
      {reactions.map((r,i)=>(
        <div key={r.ts} className="pop" style={{ background:C.surface2, border:`1px solid ${C.border}`, borderRadius:50, padding:"4px 10px", fontSize:"0.8rem", display:"flex", alignItems:"center", gap:6, animationDelay:`${i*0.05}s` }}>
          <span>{r.emoji}</span>
          <span style={{ color:C.muted, fontSize:"0.72rem" }}>{r.name}</span>
        </div>
      ))}
    </div>
  );
}

function AnswerScreen({ question, round, total, answerText, setAnswerText, locked, onSubmit, timer, totalTime, subCount, totalPlayers, onLeave, roomCode, reactions, onReact, soundOn }) {
  const words = answerText.trim().split(/\s+/).filter(Boolean);
  const handleChange = e => {
    const ws=e.target.value.trim().split(/\s+/).filter(Boolean);
    setAnswerText(ws.length>10?ws.slice(0,10).join(" "):e.target.value);
  };
  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ width:"100%", maxWidth:510 }}>
        <Dots current={round} total={total} />
        <div style={{ textAlign:"right", marginBottom:8 }}>
          <span style={{ fontSize:"0.72rem", color:C.muted }}>Room: <span style={{ color:C.yellow, fontWeight:700, letterSpacing:2 }}>{roomCode}</span></span>
        </div>
        <QBox question={question} round={round} total={total} />
        <TimerBar remaining={timer} total={totalTime} soundEnabled={soundOn} />
        {!locked ? (
          <Card className="fadeUp">
            <textarea value={answerText} onChange={handleChange} placeholder="Your best answer (max 10 words)..."
              style={{ width:"100%", padding:"13px 15px", background:C.surface2, border:`1px solid ${C.border}`, borderRadius:12, color:C.text, fontSize:"1rem", outline:"none", resize:"none", minHeight:88, marginBottom:6 }}
              onFocus={e=>e.target.style.borderColor=C.cyan} onBlur={e=>e.target.style.borderColor=C.border} />
            <div style={{ textAlign:"right", fontSize:"0.76rem", color:words.length>8?C.accent:C.muted, marginBottom:14 }}>{words.length}/10 words</div>
            <Btn onClick={(e)=>onSubmit(e)} disabled={!answerText.trim()}>Lock it in ✓</Btn>
          </Card>
        ) : (
          <Card className="pop" style={{ textAlign:"center" }}>
            <div style={{ fontSize:"2.4rem", marginBottom:10 }}>✅</div>
            <p style={{ fontWeight:600, marginBottom:5 }}>Answer locked in!</p>
            <p className="pulse" style={{ color:C.muted, fontSize:"0.87rem" }}>Waiting... ({subCount}/{totalPlayers} answered)</p>
            {/* Chat bubble reactions */}
            <div style={{ display:"flex", gap:8, justifyContent:"center", marginTop:16, flexWrap:"wrap" }}>
              {["⏳ Hurry up!","😴 I'm sleeping","😤 Urrgh!"].map(r=>(
                <button key={r} className="reaction-btn" onClick={()=>onReact(r)}>{r}</button>
              ))}
            </div>
          </Card>
        )}
        <button onClick={onLeave} style={{ marginTop:12, width:"100%", background:"transparent", border:"none", color:C.muted, fontSize:"0.82rem", cursor:"pointer", padding:"8px" }}>← Leave Room</button>
      </div>
      <ReactionBubbles reactions={reactions} />
    </div>
  );
}

function VoteScreen({ question, round, total, shuffled, myId, myVote, onVote, timer, totalTime, twoPlayer, onLeave, roomCode, soundOn }) {
  const letters = "ABCDEFGHIJKLMNOP";
  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", padding:"24px 24px 60px" }}>
      <div style={{ width:"100%", maxWidth:510, marginTop:"auto", marginBottom:"auto" }}>
        <Dots current={round} total={total} />
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:6 }}>
          <div style={{ fontSize:"0.72rem", fontWeight:600, letterSpacing:2, color:C.accent, textTransform:"uppercase" }}>Vote Phase</div>
          <span style={{ fontSize:"0.72rem", color:C.muted }}>Room: <span style={{ color:C.yellow, fontWeight:700, letterSpacing:2 }}>{roomCode}</span></span>
        </div>
        <QBox question={question} round={round} total={total} />
        <TimerBar remaining={timer} total={totalTime} soundEnabled={soundOn} />
        {!myVote ? (
          <>
            <p style={{ textAlign:"center", color:C.muted, fontSize:"0.83rem", marginBottom:12 }}>
              {twoPlayer?"Pick the best answer!":"Pick the best answer — can't vote for yourself"}
            </p>
            {shuffled.map(([id,ans],i)=>{
              const isMine = id===myId;
              const blocked = isMine && !twoPlayer;
              return (
                <div key={id} className={`ans-card${blocked?" blocked":""}`} style={{ animationDelay:`${i*0.06}s` }} onClick={(e)=>!blocked&&!myVote&&onVote(id,e)}>
                  <div style={{ width:33, height:33, borderRadius:"50%", flexShrink:0, background:C.surface, border:`1px solid ${C.border}`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Syne',sans-serif", fontWeight:700, fontSize:"0.8rem" }}>
                    {letters[i]}
                  </div>
                  <span style={{ flex:1, fontSize:"0.93rem" }}>{ans.text}</span>
                  {isMine&&!twoPlayer&&<span style={{ fontSize:"0.72rem", color:C.muted }}>yours</span>}
                </div>
              );
            })}
          </>
        ) : (
          <Card className="pop" style={{ textAlign:"center" }}>
            <div style={{ fontSize:"2.4rem", marginBottom:10 }}>🗳️</div>
            <p style={{ fontWeight:600, marginBottom:5 }}>Vote cast!</p>
            <p className="pulse" style={{ color:C.muted, fontSize:"0.87rem" }}>Waiting for results...</p>
          </Card>
        )}
        <button onClick={onLeave} style={{ marginTop:12, width:"100%", background:"transparent", border:"none", color:C.muted, fontSize:"0.82rem", cursor:"pointer", padding:"8px" }}>← Leave Room</button>
      </div>
    </div>
  );
}

function ResultsScreen({ snap, players, round, total, isHost, onNext, onLeave, myId, streaks, prevScores }) {
  const sorted = Object.entries(snap.answers).sort((a,b)=>(b[1]._votes?.length||0)-(a[1]._votes?.length||0));
  const [displayScores, setDisplayScores] = useState({});
  const medals=["🥇","🥈","🥉"];

  // Animate scores ticking up
  useEffect(()=>{
    const zeros = {};
    Object.keys(snap.scores).forEach(id=>{ zeros[id]=0; });
    setDisplayScores(zeros);
    const targets = snap.scores;
    let frame = 0; const totalFrames = 20;
    const interval = setInterval(()=>{
      frame++;
      const next = {};
      Object.keys(targets).forEach(id=>{
        next[id] = Math.round((targets[id] / totalFrames) * frame);
      });
      setDisplayScores(next);
      if (frame >= totalFrames) { setDisplayScores(targets); clearInterval(interval); }
    }, 50);
    return ()=>clearInterval(interval);
  },[snap.scores]);

  const sortedScores = Object.entries(snap.scores).sort((a,b)=>b[1]-a[1]);

  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", padding:"24px 24px 60px" }}>
      <div style={{ width:"100%", maxWidth:510, marginTop:"auto", marginBottom:"auto" }}>
        <div style={{ textAlign:"center", marginBottom:8, fontSize:"0.72rem", fontWeight:600, letterSpacing:2, color:C.accent, textTransform:"uppercase" }}>Round {round} Results</div>
        <div style={{ background:`linear-gradient(135deg,${C.surface2},#221c46)`, border:`1px solid rgba(123,47,247,.3)`, borderRadius:16, padding:"16px 18px", textAlign:"center", marginBottom:16 }}>
          <p style={{ fontFamily:"'Syne',sans-serif", fontSize:"1.05rem", fontWeight:700 }}>{snap.question}</p>
        </div>
        {sorted.map(([id,ans],i)=>{
          const v=ans._votes?.length||0;
          return (
            <div key={id} className={`res-item${i===0?" r1":i===1?" r2":i===2?" r3":""} fadeUp`} style={{ animationDelay:`${i*0.08}s` }}>
              <span style={{ fontSize:"1.3rem", minWidth:26 }}>{medals[i]||""}</span>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:500, fontSize:"0.93rem" }}>{ans.text}</div>
                <div style={{ fontSize:"0.76rem", color:C.muted, marginTop:2 }}>— {ans.authorName}</div>
              </div>
              <div style={{ padding:"3px 11px", borderRadius:50, fontSize:"0.78rem", fontWeight:700, background:"rgba(255,77,109,.14)", color:C.accent, border:"1px solid rgba(255,77,109,.22)", whiteSpace:"nowrap" }}>
                {v} vote{v!==1?"s":""}
              </div>
            </div>
          );
        })}
        <Card style={{ marginTop:16 }}>
          <div style={{ fontWeight:700, fontFamily:"'Syne',sans-serif", marginBottom:12 }}>Scoreboard</div>
          {sortedScores.map(([id,pts],i)=>{
            const streak=streaks?.[id]||0;
            const prev=prevScores?.[id]||0;
            const gained=pts-prev;
            const isLast=i===sortedScores.length-1&&sortedScores.length>1;
            const roasts=["😬 Yikes. Try harder.","💀 You good?","🤡 Carried by luck?","😴 Wake up!","🥲 Almost!"];
            return (
              <div key={id} className="sc-row fadeUp" style={{ animationDelay:`${i*0.05}s` }}>
                <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:"1.25rem", width:32, color:i===0?C.yellow:C.muted }}>{i+1}</div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:500, display:"flex", alignItems:"center", gap:4, flexWrap:"wrap" }}>
                    <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:"140px" }}>{players[id]?.name||"?"}</span>
                    {id===myId&&<span style={{ fontSize:"0.72rem", color:C.cyan, fontWeight:600 }}>(you)</span>}
                    {streak>=2&&<span className="streak-fire">🔥</span>}
                  </div>
                  {isLast&&<div className="roast-msg">{roasts[Math.floor(Date.now()/1000)%roasts.length]}</div>}
                </div>
                <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", flexShrink:0 }}>
                  <div className={gained>0?"score-flash":"score-animated"} style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, fontSize:"1.05rem", color:C.cyan }}>{displayScores[id]??pts} pts</div>
                  {gained>0&&<div className="gained-pts">+{gained}</div>}
                </div>
              </div>
            );
          })}
        </Card>
        <div style={{ marginTop:16 }}>
          {isHost
            ? <Btn onClick={onNext}>{round>=total?"See Final Results 🏆":"Next Round →"}</Btn>
            : <p className="pulse" style={{ textAlign:"center", color:C.muted, fontSize:"0.9rem", padding:"14px 0" }}>Waiting for host...</p>
          }
          <button onClick={onLeave} style={{ marginTop:10, width:"100%", background:"transparent", border:"none", color:C.muted, fontSize:"0.82rem", cursor:"pointer", padding:"8px" }}>← Leave Room</button>
        </div>
      </div>
    </div>
  );
}

function FinalScreen({ scores, players, answers, onPlayAgain, onLeave, myId, isHost, recap, roomCode }) {
  // Fix 8: sort by score, tiebreak by earliest answer submission time
  // Collect earliest submittedAt per player across all answers in results
  const submitTimes = {};
  if (answers) {
    Object.entries(answers).forEach(([pid, a])=>{
      if (a.submittedAt) submitTimes[pid] = a.submittedAt;
    });
  }
  const sorted = Object.entries(scores).sort((a,b)=>{
    if (b[1] !== a[1]) return b[1]-a[1]; // higher score first
    const ta = submitTimes[a[0]] || Infinity;
    const tb = submitTimes[b[0]] || Infinity;
    return ta - tb; // earlier submission wins tiebreak
  });
  const podOrder=sorted.length>=3?[sorted[1],sorted[0],sorted[2]]:sorted;
  const podH=[90,130,65];
  const [showRecap, setShowRecap] = useState(false);
  const [waitingHost, setWaitingHost] = useState(false);

  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24, position:"relative", overflow:"hidden" }}>
      <Confetti />
      <div style={{ width:"100%", maxWidth:500, position:"relative", zIndex:1 }}>
        <div style={{ textAlign:"center", marginBottom:6, fontSize:"0.72rem", fontWeight:600, letterSpacing:3, color:C.accent, textTransform:"uppercase" }}>Game Over</div>
        <h1 className="grad-text pop" style={{ fontFamily:"'Syne',sans-serif", fontSize:"clamp(2rem,6vw,3rem)", fontWeight:900, textAlign:"center", marginBottom:4 }}>Final Results!</h1>
        <p style={{ textAlign:"center", color:C.muted, marginBottom:26, fontSize:"0.9rem" }}>The verdicts are in 🎉</p>
        {sorted.length>=2&&(
          <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"center", gap:10, marginBottom:26 }}>
            {/* Always show 3 podium slots — blur/grey out 3rd if only 2 players */}
            {[sorted[1], sorted[0], sorted[2]].map((entry,i)=>{
              const isEmpty = !entry;
              const [id,pts] = entry||["",0];
              const rankIdx  = entry ? sorted.indexOf(entry) : 2;
              const medal    = rankIdx===0?"🥇":rankIdx===1?"🥈":"🥉";
              return (
                <div key={id||`empty-${i}`} className="fadeUp" style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:6, animationDelay:`${i*0.1}s`, opacity: isEmpty ? 0.25 : 1, filter: isEmpty ? "grayscale(1)" : "none" }}>
                  <div style={{ fontSize:"1.3rem" }}>{isEmpty?"🥉":medal}</div>
                  <div style={{ width:78, height:podH[i], borderRadius:"10px 10px 0 0", background:C.surface2, border:`1px solid ${C.border}`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:"1.4rem", color:rankIdx===0?C.yellow:C.muted }}>
                    {isEmpty?"3":rankIdx+1}
                  </div>
                  <div style={{ fontSize:"0.76rem", color:C.muted, textAlign:"center", maxWidth:78, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                    {isEmpty?"—":players[id]?.name||"?"}{!isEmpty&&id===myId&&" (you)"}
                  </div>
                  <div style={{ fontSize:"0.78rem", color: isEmpty?C.muted:C.cyan, fontWeight:700 }}>{isEmpty?"—":pts+"pts"}</div>
                </div>
              );
            })}
          </div>
        )}
        <Card>
          {sorted.map(([id,pts],i)=>{
            // Show "ranked higher" on the person who WON the tiebreak:
            // = same score as the person directly below them, AND answered faster
            const nextEntry = sorted[i+1];
            const nextPts   = nextEntry?.[1];
            const nextId    = nextEntry?.[0];
            const wonTiebreak = nextPts===pts
              && submitTimes[id] && submitTimes[nextId]
              && submitTimes[id] < submitTimes[nextId];
            return (
              <div key={id} className="sc-row fadeUp" style={{ animationDelay:`${i*0.06}s` }}>
                <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:800, fontSize:"1.35rem", width:34, color:i===0?C.yellow:C.muted }}>{i===0?"🏆":i+1}</div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{players[id]?.name||"?"}{id===myId&&<span style={{ marginLeft:6, fontSize:"0.72rem", color:C.cyan, fontWeight:600 }}>(you)</span>}</div>
                  {wonTiebreak && <div style={{ fontSize:"0.65rem", color:C.muted, marginTop:1 }}>ranked higher due to quick answers</div>}
                </div>
                <div style={{ marginLeft:8, fontFamily:"'Syne',sans-serif", fontWeight:700, fontSize:"1.05rem", color:C.cyan, flexShrink:0 }}>{pts} pts</div>
              </div>
            );
          })}
        </Card>

        {/* Round Recap */}
        {recap && (
          <div style={{ marginTop:16 }}>
            <button onClick={()=>setShowRecap(s=>!s)} style={{ width:"100%", background:C.surface2, border:`1px solid ${C.border}`, borderRadius:14, padding:"12px 16px", color:C.text, cursor:"pointer", fontFamily:"'Outfit',sans-serif", fontSize:"0.9rem", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <span>🎬 Game Recap</span>
              <span style={{ color:C.muted }}>{showRecap?"▲":"▼"}</span>
            </button>
            {showRecap && (
              <Card style={{ marginTop:8, display:"flex", flexDirection:"column", gap:12 }} className="fadeUp">
                {recap.mostVotes && (
                  <div>
                    <div style={{ fontSize:"0.72rem", color:C.cyan, fontWeight:600, marginBottom:4, letterSpacing:1 }}>🔥 MOST VOTED ANSWER</div>
                    <div style={{ fontWeight:500, fontSize:"0.9rem" }}>"{recap.mostVotes.text}"</div>
                    <div style={{ fontSize:"0.76rem", color:C.muted }}>— {recap.mostVotes.authorName} · {recap.mostVotes.votes} votes</div>
                  </div>
                )}
                {recap.mostChaos && (
                  <div>
                    <div style={{ fontSize:"0.72rem", color:C.accent, fontWeight:600, marginBottom:4, letterSpacing:1 }}>😂 MOST CHAOTIC ROUND</div>
                    <div style={{ fontSize:"0.88rem", color:C.muted }}>"{recap.mostChaos}"</div>
                  </div>
                )}
                {recap.mvp && players[recap.mvp.id] && (
                  <div>
                    <div style={{ fontSize:"0.72rem", color:C.yellow, fontWeight:600, marginBottom:4, letterSpacing:1 }}>👑 MVP</div>
                    <div style={{ fontWeight:600 }}>{players[recap.mvp.id]?.name} — {recap.mvp.pts} pts</div>
                  </div>
                )}
              </Card>
            )}
          </div>
        )}

        <div style={{ marginTop:16 }}>
          {isHost
            ? <Btn onClick={onPlayAgain}>Play Again 🔁</Btn>
            : waitingHost
              ? <p className="pulse" style={{ textAlign:"center", color:C.muted, fontSize:"0.9rem", padding:"14px 0" }}>Waiting for host to restart...</p>
              : <Btn variant="ghost" onClick={()=>setWaitingHost(true)}>Ready for next game? ✋</Btn>
          }
          <button onClick={onLeave} style={{ marginTop:10, width:"100%", background:"transparent", border:"none", color:C.muted, fontSize:"0.82rem", cursor:"pointer", padding:"8px" }}>← Back to Home</button>
        </div>
      </div>
    </div>
  );
}